var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._g(_vm._b({
    staticClass: "pa-0",
    attrs: {
      "elevation": "0",
      "min-width": 0,
      "width": _vm.sizePx,
      "height": _vm.sizePx
    }
  }, 'v-btn', _vm.$attrs, false), _vm.$listeners), [_c('v-icon', {
    attrs: {
      "size": _vm.iconSize
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }